<template>
  <nav class="card-tabs" role="tablist">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      role="tab"
      class="card-tabs__item"
      :class="{ _active: tab.key === current }"
      :aria-selected="tab.key === current"
      @click="$emit('select', tab.key)"
    >
      <SatIcon :name="tab.icon" :size="15" />
      {{ $t(`platform.card.tabs.${tab.key}`) }}
      <span v-if="marks[tab.key]" class="sat-dot" :class="`_${marks[tab.key]}`" :title="$t(`platform.card.marks.${marks[tab.key]}`)"></span>
    </button>
  </nav>
</template>
<script>
import SatIcon from "@/components/Satellites/SatIcon.vue";

// Tabs of the platform card. `marks` flags tabs with unsaved changes ("warn") or errors ("danger").
export default {
  name: "CardTabs",
  components: { SatIcon },
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    current: {
      type: String,
      required: true,
    },
    marks: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    // On narrow screens the tabs scroll sideways: keep the open one in sight
    current: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          const active = this.$el && this.$el.querySelector("._active");
          if (active) active.scrollIntoView({ block: "nearest", inline: "nearest" });
        });
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.card-tabs {
  display: flex;
  gap: 0 26px;
  margin-bottom: 22px;
  overflow-x: auto;
  border-bottom: 1px solid var(--sat-border);
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.card-tabs__item {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 0;
  margin-bottom: -1px;
  border: 0;
  border-bottom: 2px solid transparent;
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
  color: var(--sat-muted);
  background: transparent;
  cursor: pointer;
  transition: color 0.15s;

  &:hover {
    color: var(--sat-text);
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    color: var(--sat-text);
    box-shadow: inset 0 -2px 0 var(--sat-accent);
  }

  &._active {
    color: var(--sat-accent);
    border-bottom-color: var(--sat-accent);
  }
}
</style>
